export default __webpack_public_path__ + "static/media/EmptyList.15c2deed.png";